import { call, fork, put, takeEvery } from 'redux-saga/effects';
import * as ga from '../../redux/actions/app';

import {
  getSupervisorDashboardDataSuccess,
  NS_GET_SUPERVISOR_DASHBOARD_DATA
} from '../../redux/actions/ns/supervisorDashboard';

import { getSupervisorDashboard } from '../../services/ns/supervisorDashboard';

function* getSupervisorDashboardDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getSupervisorDashboard, payload);
    yield put(getSupervisorDashboardDataSuccess(response.data));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetSupervisorDashboardData() {
  yield takeEvery(NS_GET_SUPERVISOR_DASHBOARD_DATA, function* ({ payload }) {
    yield fork(getSupervisorDashboardDataWorker, payload);
  });
}
